// Identifiants client des opérations et des photos : UUID version 7 (D-041), ordonnés dans le
// temps (48 bits d'horodatage en millisecondes puis 74 bits aléatoires), générés sur l'appareil
// sans dépendance, pour que le serveur reconnaisse un doublon rejoué après une coupure.

export function uuidV7(horodatage = Date.now()): string {
  const o = new Uint8Array(16);
  crypto.getRandomValues(o);
  const haut = Math.floor(horodatage / 2 ** 32);
  const bas = horodatage % 2 ** 32;
  o[0] = (haut >>> 8) & 0xff;
  o[1] = haut & 0xff;
  o[2] = (bas >>> 24) & 0xff;
  o[3] = (bas >>> 16) & 0xff;
  o[4] = (bas >>> 8) & 0xff;
  o[5] = bas & 0xff;
  o[6] = ((o[6] as number) & 0x0f) | 0x70;
  o[8] = ((o[8] as number) & 0x3f) | 0x80;
  const hex = Array.from(o, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Horodatage (ms) porté par un UUID v7, pour trier ou dater sans autre champ. */
export function horodatageUuidV7(uuid: string): number {
  return Number.parseInt(uuid.replace(/-/g, '').slice(0, 12), 16);
}

export const EXPRESSION_UUID_V7 = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
